import { ActionTypes } from 'redux/utils/Details'
export default ActionTypes('REFERRAL_INFO_DETAILS_REQUEST')